export const CONSTANTS = {
  BATCH_SIZE: 300,
  CHUNK_SIZE: 1024 * 1024,
  MAX_FILE_SIZE: 30 * 1024 * 1024,
  MAX_EXCEL_FILE_SIZE: 1024 * 1024,
  WORKER_FILE_SIZE_THRESHOLD: 10 * 1024 * 1024,
  QSO_DEDUP_TIME_THRESHOLD: 30 * 60 * 1000,
  MIN_PASSWORD_LENGTH: 6,
  COMPRESSION_LEVEL: 6,
} as const;

export const ADIF_FIELDS = {
  CALL: "CALL",
  QSO_DATE: "QSO_DATE",
  TIME_ON: "TIME_ON",
  FREQ: "FREQ",
  BAND: "BAND",
  MODE: "MODE",
  RST_SENT: "RST_SENT",
  RST_RCVD: "RST_RCVD",
  QSL_RCVD: "QSL_RCVD",
  POTA: "POTA",
  CONTEST_ID: "CONTEST_ID",
  COMMENT: "COMMENT",
} as const;

export const CSV_COLUMNS = {
  CALL: "CALL",
  ADDRESS: "ADDRESS",
  ZIP: "ZIP",
  NOTE: "NOTE",
  OUTSEA: "OUTSEA",
} as const;
